import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
import ActionDialogSchoolYear from './ActionDialogSchoolYear';


function ShowSchoolYear (props)  {
  const listSchoolYear = useSelector(state => state.school_year);
    const [rowDataState, setRowDataState] = useState([]);
    const [statusButton, setStatusButton] = React.useState(false);

      const [tableColumns, setTableColumns] = useState([]);
      const [tableList, setTableList] = useState([]);
      
      const columns = [
        {
          name: 'id',
          options: {
            filter: false,
            display: false,       
            viewColumns: false,
            print: false,
            download: false,     
          }
        },
        {
          label: 'Nombre',
          name: 'year',
          options: {
            filter: true,
          }
        },
        {
            label: 'Estado',
            name: 'status',
            options: {
              filter: true,
            }
          },
      ];

     /**
 * Method to set the documents list and tabe columns
 */
  useEffect(() => {
    if (listSchoolYear && listSchoolYear.length >= 0) {
      setTableColumns(columns);
      setTableList(listSchoolYear);
    }
  }, [listSchoolYear]);
 
    
  
      /**
       * Method to recoer the specifid values of the row
       * @param {rowData} rowData
       */
      const handleRowData = (rowData) => {
        const rowDataTemp = [];
        rowDataTemp.length = 0;
        rowDataTemp.push(rowData[0]);
        rowDataTemp.push(rowData[1]);
        rowDataTemp.push(rowData[2]);
        setRowDataState(rowDataTemp);   
      };
    
      const handleCloseButton = () => {
        setStatusButton(false);
      };
    
      const options = {
        selectableRowsHideCheckboxes: true,
        selectableRows: 'single',
        filterType: 'dropdown',
        responsive: 'standard',
        print: true,
        selectableRowsOnClick: false,
        rowsPerPage: 10,
        downloadOptions: {
          filename: 'lp',
          filterOptions: {
            useDisplayedRowsOnly: true,
          }
        },
        onDownload: (buildHead, buildBody, columnsData, data) => {
          const val = '\uFEFF' + `${buildHead(columnsData)}${buildBody(data)}`.trim();
          return val;
        },
        onRowClick: (rowData) => {          
          handleRowData(rowData);
          setStatusButton(true);
        }
      };
    
      return (
        <div>
        <div>
          <MUIDataTable
            title='Año Lectivo'
            data={tableList}
            columns={tableColumns}
            options={options}
          />
          <ActionDialogSchoolYear openStatus={statusButton} onClosed= {handleCloseButton} rowData={rowDataState}/>
        </div>
        </div>
      );
}

ShowSchoolYear.propTypes = {
  dataTeacher: PropTypes.string,
};

ShowSchoolYear.defaultProps = {
  dataTeacher: "true"
};

export default ShowSchoolYear